import { appConfig as $config } from '../../app.config';
import { Common } from '../../modules/Common';
import { UI } from '../../modules/UI';
import { User } from '../../modules/User';
import { PageSearch } from '../../modules/PageSearch';

import { ProductInfo } from '../../modules/ProductInfo';
import { ArtworkInfo } from '../../modules/ArtworkInfo';

import './scss/transactions.scss';
import { App } from '../../modules/App';
import { SortFilter } from '../../modules/SortFilter';

export const Transactions = (function () {
  let selectedStore = 'Shopify';
  let selectedProduct = '';
  let $dataGrid,
    $datesRangeDefaults = {
      start: moment(new Date(2019, 0, 1)),
      end: moment()
    };

  const DT_Columns = [
    {
      data: null,
      width: 30,
      defaultContent: '',
      className: 'control',
      orderable: false,
      sortable: false,
      responsivePriority: 0
    },
    {
      title: '',
      data: 'productImage',
      orderable: false,
      sortable: false,
      searchable: false,
      render: (data, type, full) => {
        return UI.thumbnail(data);
      }
    },
    {
      title: $Lang.transactions.productName,
      data: 'licensedProductName',
      className: 'text-capitalize',
      render: (data, type, full) => {
        return `<a href="javascript:" data-id="${
          full.licensedProductId ? full.licensedProductId : ''
        }" data-accountid="${full.accountId ? full.accountId : ''}" class="product-name">${data}</a>`;
      }
    },
    {
      title: $Lang.transactions.transactionId,
      data: 'transactionId',
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<a href="javascript:">${data}</a>`;
      }
    },
    {
      title: $Lang.transactions.date,
      data: 'date',
      orderable: true,
      sortable: true,
      searchable: false,
      className: 'text-nowrap',
      render: (data, type, full) => {
        return moment(data).format('MMM DD, YYYY');
      }
    },
    {
      title: $Lang.transactions.status,
      data: 'status',
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<span class="kt-badge kt-badge--outline kt-badge--${
          data == 'Cancelled' ? 'danger' : 'success'
        } text-nowrap">${data}</span>`;
      }
    },
    {
      title: $Lang.transactions.artwork,
      data: 'artworkName',
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<a href="javascript:" data-id="${full.artworkId ? full.artworkId : ''}" data-accountid="${
          full.accountId ? full.accountId : ''
        }" class="artwork-name">${data}</a>`;
      }
    },
    { title: $Lang.transactions.blank, data: 'blankName', orderable: true, sortable: true, searchable: false },
    {
      title: $Lang.transactions.storeId,
      data: { storeId: 'storeId', storeUrl: 'storeUrl' },
      orderable: false,
      sortable: false,
      searchable: false,
      render: (data, type, full) => {
        return `<a href="${data.storeUrl}" target="_blank">${data.storeId}</a>`;
      }
    },
    {
      title: $Lang.transactions.price,
      data: { price: 'price', currencyCode: 'currencyCode' },
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<span class="text-right">${data.price} ${data.currencyCode}</span>`;
      }
    },
    {
      title: $Lang.transactions.quantity,
      data: 'quantity',
      orderable: true,
      sortable: true,
      searchable: false,
      className: 'text-right'
    },
    {
      title: $Lang.transactions.totalSales,
      data: { totalSales: 'totalSales', currencyCode: 'currencyCode' },
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      render: (data, type, full) => {
        return `<span class="text-right">${data.totalSales} ${data.currencyCode}</span>`;
      }
    },
    {
      title: $Lang.transactions.licensorRoyalty,
      data: 'licensorCommission',
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      render: (data) => (data * 1).toFixed(2)
    },
    {
      title: $Lang.transactions.licenseeRoyalty,
      data: 'licenseeCommission',
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      render: (data) => (data * 1).toFixed(2)
    },
    {
      title: $Lang.transactions.agentRoyalty,
      data: 'agentCommission',
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      render: (data) => (data * 1).toFixed(2)
    },
    {
      title: $Lang.transactions.netProfit,
      data: 'netProfit',
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      render: (data) => (data * 1).toFixed(2)
    }
  ];

  let mapping = {
    transactions: (data) => {
      return $.map(data, function (trans) {
        trans.DT_RowId = trans.id;
        return trans;
      });
    },
    datesRangeFormat: (data) => {
      return {
        start: moment(data.start).format($config.appFullDateFormat),
        end: moment(data.end).format($config.appFullDateFormat)
      };
    }
  };

  let init = () => {
    let uri = Common.segmentedURI();
    selectedStore = Common.getQueryVal('Store', uri.query) || selectedStore;
    selectedProduct = Common.getQueryVal('ProductId', uri.query) || selectedProduct;
    let pageData = {
      datesRange: mapping.datesRangeFormat($datesRangeDefaults),
      stores: ['All', 'Shopify', 'Amazon', 'Tradebyte'],
      selectedStore: selectedStore,
      selectedProduct: selectedProduct
    };

    let template = require('./tmpl/transactions.hbs');
    UI.page(template, pageData).then(dataGridInit);
  };

  let dataGridInit = () => {
    UI.block('#page');

    $dataGrid = $('#TransactionsDataTable')
      .DataTable({
        columns: DT_Columns,
        ajax: ajaxData,
        autoWidth: false,
        //      order          : [3, 'desc'],
        searching: false,
        ordering: false,
        serverSide: true,
        stateSave: false,
        cache: false,
        responsive: {
          details: {
            type: 'column',
            target: 0
          }
        },
        drawCallback: drawCallback,
        dom: '<"row"<"col text-right"p>><"row"<"col-sm-12"t>><"row"<"col-sm-12 text-right"p>>',
        rowCallback: function (row, data, index) {
          if (data.status == 'Cancelled') {
            $(row).addClass('bg-secondary');
          }
        },
        initComplete: () => {
          UI.unblock('#page');
        }
      })
      .on('responsive-resize', () => {
        $dataGrid.columns.adjust().responsive.recalc();
      });
  };

  let ajaxData = (data, callback) => {
    let sendData = {
      pageLimit: data.length,
      page: data.start / data.length + 1,
      requestPage: 'Transactions',
      storeName: selectedStore
    };

    $.when(App.ajaxData('Transactions/filter', sendData, 'POST')).done((res) => {
      if (!SortFilter.isInit('#transactionsFilters')) {
        SortFilter.init({
          selector: '#transactionsFilters',
          update: () => {
            $dataGrid.draw();
          }
        });
      }

      callback({
        recordsTotal: res.totalCount || 0,
        recordsFiltered: res.totalCount || 0,
        data: mapping.transactions(res.data)
      });
    });
  };

  let drawCallback = () => {
    UI.unblock('#page');

    // Image popup
    $('.magnific-image').magnificPopup({ type: 'image' });

    $('.product-name')
      .off()
      .on('click', function () {
        let id = $(this).data('id') || false;
        let accountId = $(this).data('accountid') || false;
        ProductInfo.dialog(id, { accountId: accountId, pageUrl: 'listings' });
      });

    $('.artwork-name')
      .off()
      .on('click', function () {
        let id = $(this).data('id') || false;
        let accountId = $(this).data('accountid') || false;
        ArtworkInfo.dialog(id, () => {}, true, accountId);
      });
  };

  return {
    init
  };
})();
